"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _offers = _interopRequireDefault(require("../offers"));
var panelPropTypes = {
  offers: _propTypes.default.arrayOf(_propTypes.default.object),
  index: _propTypes.default.number,
  monthlyIndexSup: _propTypes.default.number,
  colSize: _propTypes.default.number,
  selectedOffer: _propTypes.default.number,
  onChange: _propTypes.default.func,
  constants: _propTypes.default.object,
  productType: _propTypes.default.string
};
var getCardTitleAndDesc = function getCardTitleAndDesc(productType, constants) {
  switch (productType) {
    case 'IF':
      return {
        title: constants.INTEREST_FREE_LOAN.pluralName,
        description: /*#__PURE__*/_react.default.createElement("div", {
          className: "card-description"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "card-rate"
        }, "No Interest for 6 or 12 mo"), /*#__PURE__*/_react.default.createElement("br", null), " after that, 26.99% standard APR")
      };
    case 'PRP':
      return {
        title: constants.PROMOTIONAL_RATE_PLAN.pluralName,
        description: /*#__PURE__*/_react.default.createElement("div", {
          className: "card-description"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "card-rate"
        }, "17.90% APR for 24, 36, 48 or 60 mo"), /*#__PURE__*/_react.default.createElement("br", null), " after that, 26.99% standard APR")
      };
    case 'IL':
      return {
        title: constants.INSTALLMENT_LOAN.pluralName,
        description: /*#__PURE__*/_react.default.createElement("div", {
          className: "card-description"
        }, "Payment amount and interest rate will stay", /*#__PURE__*/_react.default.createElement("br", null), "the same as the loan is paid off")
      };
    case 'LCFRP':
      return {
        title: constants.LC_FIXED_RATE_PLAN.displayName,
        description: /*#__PURE__*/_react.default.createElement("div", {
          className: "card-description"
        }, "Rate based on amount financed and credit history.", /*#__PURE__*/_react.default.createElement("br", null), "Payment amount stays the same as loan is paid off.")
      };
    case 'LCTNI':
      return {
        title: constants.LC_TRUE_NO_INTEREST.displayName,
        description: /*#__PURE__*/_react.default.createElement("div", {
          className: "card-description"
        }, "Pay no interest for up to 36 months")
      };
    default:
      return {
        title: '',
        description: ''
      };
  }
};
var Panel = function Panel(_ref) {
  var offers = _ref.offers,
    index = _ref.index,
    colSize = _ref.colSize,
    selectedOffer = _ref.selectedOffer,
    onChange = _ref.onChange,
    constants = _ref.constants,
    monthlyIndexSup = _ref.monthlyIndexSup,
    productType = _ref.productType;
  var _getCardTitleAndDesc = getCardTitleAndDesc(productType, constants),
    title = _getCardTitleAndDesc.title,
    description = _getCardTitleAndDesc.description;
  return offers && offers.length ? /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-".concat(colSize)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-container-primary desktop-columns-".concat(colSize)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-heading"
  }, /*#__PURE__*/_react.default.createElement("span", null, title, /*#__PURE__*/_react.default.createElement("sup", {
    className: "disclosure"
  }, index))), /*#__PURE__*/_react.default.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-metrics"
  }, description), /*#__PURE__*/_react.default.createElement("div", {
    className: "card-offers"
  }, /*#__PURE__*/_react.default.createElement(_offers.default, {
    monthlyIndexSup: monthlyIndexSup,
    offers: offers,
    productType: productType.toLowerCase(),
    selectedOffer: selectedOffer,
    onSelection: onChange
  }))))) : null;
};
Panel.propTypes = panelPropTypes;
var _default = Panel;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-revisions/dist/pf-revisions.scss');